import { BRAND_COLORS, ERROR_COLORS, FONT_WEIGHTS, GRAY_COLORS, SHADOWS } from '../globalTheme';

export const theme = {
	input: {
		size: {
			xsmall: {
				width: 'auto',
				height: '30px',
				padding: '10px 14px',
				fontSize: '14px'
			},
			default: {
				width: '320px',
				height: '44px',
				padding: '10px 14px',
				fontSize: '16px'
			},
			promptBar: {
				width: '380px',
				height: '56px',
				padding: '10px 14px',
				fontSize: '16px'
			},
			largePromptBar: {
				width: '535px',
				height: '56px',
				padding: '10px 14px',
				fontSize: '16px'
			},
			auto: {
				width: 'auto',
				height: '48px',
				padding: '10px 14px',
				fontSize: '16px'
			},
			small: {
				width: 'auto',
				height: '40px',
				padding: '10px 12px',
				fontSize: '14px'
			}
		},
		shape: {
			default: { borderRadius: '8px' },
			pill: { borderRadius: '30px' }
		},
		inputBorder: {
			border: `1px solid ${GRAY_COLORS.gray300}`
		},
		backgroundColor: 'white',
		inputShadow: SHADOWS.xs,
		focused: {
			border: `1px solid ${BRAND_COLORS.brand300}`,
			boxShadow: `0px 0px 0px 4px ${BRAND_COLORS.brand100}`
		},
		disabled: {
			background: GRAY_COLORS.gray100,
			color: GRAY_COLORS.gray400
		},
		error: {
			border: `1px solid ${ERROR_COLORS.error300}`
		},
		errorFocused: {
			boxShadow: `0px 0px 0px 4px ${ERROR_COLORS.error100}`
		},
		textArea: {
			display: 'flex',
			items: 'center',
			height: 'auto'
		}
	},
	placeholder: {
		weight: FONT_WEIGHTS.regular
	},
	inputLabel: {
		color: GRAY_COLORS.gray700
	},
	inputHint: {
		color: GRAY_COLORS.gray600,
		fontSize: '14px',
		errorColor: ERROR_COLORS.error500
	},
	iconColors: {
		loading: BRAND_COLORS.brand300,
		error: ERROR_COLORS.error500,
		tooltip: GRAY_COLORS.gray400
	}
};
export type Theme = typeof theme;
export type InputFieldSize = keyof Theme['input']['size'];
export type InputFieldShape = keyof Theme['input']['shape'];
